import * as types from '../mutation-types'
import { api } from '@/modules/api/index'
import { path } from 'ramda'

export const state = {
  categories: [],
  enabledCategories: [],
  totalCategoriesPages: 0,
  totalCategoriesItems: 0
}

export const getters = {
  categoriesList: state => state.categories,
  enabledCategoriesList: state => state.enabledCategories,
  totalCategoriesPages: state => state.totalCategoriesPages,
  totalCategoriesItems: state => state.totalCategoriesItems
}

export const actions = {
  async getCategoriesList ({ commit }, getProperty = {}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.categories.getCategoriesList(getProperty))
      commit(types.SET_CATEGORIES_LIST, response.data)
      return response.data.categories
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Categories wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async addCategoryList ({ commit }, newCategory) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.categories.addCategoryList(), { ...newCategory })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Categories were added successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Categories weren\'t added')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async editCategoryList ({ commit }, editCategory) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.categories.editCategoryList(), { ...editCategory })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Categories was edited successfully')
    } catch (err) {
      if (err.response.data.Code === 'validation.base-0001') {
        this.dispatch('showResultErrorMessage', path(['response', 'data', 'Message'], err) + ' ' + path(['response', 'data', 'ValidationFailures', '0', 'errorMessage'], err))
      } else {
        commit(types.CREATE_ERROR_MESSAGE, 'Categories wasn\'t edited')
      }
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async deleteCategoryList ({ commit }, deleteCategoryId) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.categories.deleteCategoryList(deleteCategoryId))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Categories was deleted successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Categories wasn\'t deleted')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async getEnabledCategoriesList ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.categories.getEnabledCategoriesList())
      commit(types.SET_ENABLED_CATEGORIES_LIST, response.data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Categories wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

export const mutations = {
  [types.SET_CATEGORIES_LIST] (state, { categories, totalPages, totalItems }) {
    state.categories = [...categories]
    state.totalCategoriesPages = totalPages
    state.totalCategoriesItems = totalItems
  },
  [types.SET_ENABLED_CATEGORIES_LIST] (state, { categories }) {
    state.enabledCategories = [...categories]
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/categories.js